export default __webpack_public_path__ + "static/media/citlogo_dark.89c3cf70.svg";